module.exports = __webpack_public_path__ + "img/jason.f3ff996b.png";